import styles from "./Feedback.module.css";
import classNames from "classnames";
import { JSX, useEffect, useState } from "react";
import { useI18n } from "../../i18n";
import { FeedbackSchema, getFeedback, persistValue, STORAGE_FEEDBACK_KEY } from "../../services";

const ThumbsDown = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24">
      <path
        d="M6.5 3H17.5V16L10.5 23L9.25 21.75C9.13333 21.6333 9.0375 21.475 8.9625 21.275C8.8875 21.075 8.85 20.8833 8.85 20.7V20.35L9.95 16H3.5C2.96667 16 2.5 15.8 2.1 15.4C1.7 15 1.5 14.5333 1.5 14V12C1.5 11.8833 1.51667 11.7583 1.55 11.625C1.58333 11.4917 1.61667 11.3667 1.65 11.25L4.65 4.2C4.8 3.86667 5.05 3.58333 5.4 3.35C5.75 3.11667 6.11667 3 6.5 3ZM15.5 5H6.5L3.5 12V14H12.5L11.15 19.5L15.5 15.15V5ZM17.5 16V14H20.5V5H17.5V3H22.5V16H17.5Z"
        fill="#2B373D"
      />
      <path d="M6.5 5H15.5V15.15L11.15 19.5L12.5 14H3.5V12L6.5 5Z" />
      <rect x="17.4375" y="5" width="3.125" height="9.0625" />
    </svg>
  );
};

const ThumbsUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24">
    <path
      d="M18.5 21.5L7.5 21.5L7.5 8.5L14.5 1.5L15.75 2.75C15.8667 2.86667 15.9625 3.025 16.0375 3.225C16.1125 3.425 16.15 3.61667 16.15 3.8L16.15 4.15L15.05 8.5L21.5 8.5C22.0333 8.5 22.5 8.7 22.9 9.1C23.3 9.5 23.5 9.96667 23.5 10.5L23.5 12.5C23.5 12.6167 23.4833 12.7417 23.45 12.875C23.4167 13.0083 23.3833 13.1333 23.35 13.25L20.35 20.3C20.2 20.6333 19.95 20.9167 19.6 21.15C19.25 21.3833 18.8833 21.5 18.5 21.5ZM7.5 8.5L7.5 10.5L4.5 10.5L4.5 19.5L7.5 19.5L7.5 21.5L2.5 21.5L2.5 8.5L7.5 8.5Z"
      fill="#2B373D"
    />
    <path d="M18.5 19.5L9.5 19.5L9.5 9.35L13.85 5L12.5 10.5L21.5 10.5L21.5 12.5L18.5 19.5Z" />
    <rect x="7.5625" y="19.5" width="3.125" height="9.0625" transform="rotate(180 7.5625 19.5)" />
  </svg>
);

export const Feedback = (): JSX.Element => {
  const { t } = useI18n();
  const [feedback, setFeedback] = useState<FeedbackSchema>({ liked: undefined });
  const [show, setShow] = useState(false);

  useEffect(() => {
    getFeedback().then((result) => {
      const alreadyRated = result?.liked !== undefined;
      setShow(!alreadyRated);
    });
  }, []);

  useEffect(() => {
    const saveLocalStorage = async () => {
      await persistValue(STORAGE_FEEDBACK_KEY, { liked: feedback.liked });
    };
    saveLocalStorage().then();
  }, [feedback]);

  const idLike = feedback.liked === true ? "ThumbsUp" : "JobRadRechner_Feedback_ThumbsUp";
  const idDislike = feedback.liked === false ? "ThumbsDown" : "JobRadRechner_Feedback_ThumbsDown";
  const classLike = classNames(
    styles.thumb,
    { [styles.selectedLike]: feedback.liked },
    { [styles.active]: feedback.liked == undefined },
  );
  const classDislike = classNames(
    styles.thumb,
    { [styles.selectedDislike]: feedback.liked === false },
    { [styles.active]: feedback.liked == undefined },
  );

  return (
    (show && (
      <div className={styles.feedback}>
        <span>{t("feedbackQuestion")}</span>
        <div className={styles.controls} role="radiogroup">
          <label className={classLike} id={idLike} data-testid="labelForThumbsUp">
            <input
              className={classLike}
              type="radio"
              aria-label={t("feedbackAriaLike")}
              name="feedback"
              onChange={() => {
                setFeedback({ liked: true });
              }}
            />
            <ThumbsUp />
          </label>
          <label className={classDislike} id={idDislike} data-testid="labelForThumbsDown">
            <input
              type="radio"
              aria-label={t("feedbackAriaDisLike")}
              name="feedback"
              className={classDislike}
              onChange={() => {
                setFeedback({ liked: false });
              }}
            />
            <ThumbsDown />
          </label>
        </div>
      </div>
    )) || <></>
  );
};
